var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangesStatusOfTrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3B66B0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14,6.2c-7.3,0-13.3,5.9-13.3,13.3S14,48.8,14,48.8s13.3-21.9,13.3-29.2S21.4,6.2,14,6.2z M14,25.5 c-3.7,0-6.6-3-6.6-6.6c0-3.7,3-6.6,6.6-6.6c3.7,0,6.6,3,6.6,6.6C20.7,22.5,17.7,25.5,14,25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.6,24.1c-5.7,0-10.4,4.7-10.4,10.4c0,5.7,4.7,10.4,10.4,10.4c5.7,0,10.4-4.7,10.4-10.4 C48,28.7,43.3,24.1,37.6,24.1z M37.6,40.9c-3.5,0-6.4-2.9-6.4-6.4s2.9-6.4,6.4-6.4s6.4,2.9,6.4,6.4S41.1,40.9,37.6,40.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14,5.5h18.3c2,0,3.7,1.6,3.7,3.7v6.4h-6l3.8,3.6l3.8,3.6l3.8-3.6l3.8-3.6h-6V9.2c0-3.7-3-6.7-6.7-6.7H14 c-0.8,0-1.5,0.7-1.5,1.5S13.2,5.5,14,5.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangesStatusOfTrip);
export default __webpack_public_path__ + "static/media/changes-status-of-trip.8293511d99b62f994272842f51b7c174.svg";
export { ForwardRef as ReactComponent };